import { andJoin, createLabeledMessages } from '../../../messageUtils';
const policy = {
    duration: 'insurance duration',
    paymentFrequency: 'payment frequency',
    insuranceStart: 'insurance start',
    insuranceStartTime: 'insurance start time',
    insuranceEnd: 'insurance end',
    agreementDate: 'agreement date',
    dayCount: 'day count',
    paymentPerYear: 'payment per year',
    paymentValue: 'payment value',
    paymentType: 'payment type',
    creation: 'creation',
    specialAgreement: 'special agreement',
    note: 'note',
    paceAndDate: andJoin('address:place_label', 'policy:agreementDate'),
    insuranceType: 'insurance type'
};
export default Object.assign({}, policy, createLabeledMessages(policy));
